"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { FiPlus, FiEdit2, FiTrash2, FiEye } from "react-icons/fi"
import "./Users.css"

const Users = () => {
    const [users, setUsers] = useState([])
    const [departments, setDepartments] = useState([])
    const [permissions, setPermissions] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        password: "",
        department_id: "",
        permissions: [],
    })
    const [error, setError] = useState("")

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        try {
            const [usersRes, deptsRes, permsRes] = await Promise.all([
                api.get("/users"),
                api.get("/departments"),
                api.get("/permissions"),
            ])
            setUsers(usersRes.data.data || usersRes.data)
            setDepartments(deptsRes.data)
            setPermissions(permsRes.data)
        } catch (error) {
            console.error("Veri yüklenemedi:", error)
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("")

        // Gönderilecek veriyi kopyala
        let dataToSend = { ...formData };

        try {
            if (selectedUser) {
                // EĞER BU BİR GÜNCELLEMEYSE VE ŞİFRE BOŞ GÖNDERİLİYORSA
                if (dataToSend.password === "") {
                    // ŞİFRE ALANINI VERİDEN TAMAMEN KALDIR
                    // Böylece backend bu alanı güncellemeye çalışmaz.
                    delete dataToSend.password;
                }
                await api.put(`/users/${selectedUser.id}`, dataToSend); // dataToSend'i gönder
            } else {
                await api.post("/users", dataToSend); // dataToSend'i gönder
            }
            setShowModal(false)
            resetForm()
            loadData()
        } catch (error) {
            setError(error.response?.data?.message || "İşlem başarısız");

            // Hatanın tam olarak ne olduğunu görmek için bunu konsola yazdırın:
            if (error.response && error.response.data) {
                console.error("Validation Hatası Detayları:", error.response.data.errors);
            }
        }
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Bu personeli silmek istediğinizden emin misiniz?")) return

        try {
            await api.delete(`/users/${id}`)
            loadData()
        } catch (error) {
            alert("Silme işlemi başarısız")
        }
    }

    const handleEdit = (user) => {
        setSelectedUser(user)
        setFormData({
            first_name: user.first_name,
            last_name: user.last_name,
            phone: user.phone,
            email: user.email || "",
            password: "",
            department_id: user.department_id || "",
            permissions: user.permissions?.map((p) => p.id) || [],
        })
        setShowModal(true)
    }

    const handleViewDetail = async (user) => {
        try {
            const response = await api.get(`/users/${user.id}`)
            setSelectedUser(response.data)
            setShowDetailModal(true)
        } catch (error) {
            alert("Detay yüklenemedi")
        }
    }

    const resetForm = () => {
        setFormData({
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            password: "",
            department_id: "",
            permissions: [],
        })
        setSelectedUser(null)
        setError("")
    }

    const handlePermissionChange = (permId) => {
        setFormData((prev) => ({
            ...prev,
            permissions: prev.permissions.includes(permId)
                ? prev.permissions.filter((id) => id !== permId)
                : [...prev.permissions, permId],
        }))
    }

    if (loading) {
        return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
    }

    return React.createElement(
        "div",
        { className: "users-page" },
        React.createElement(
            "div",
            { className: "page-header" },
            React.createElement("h1", null, "Personel Yönetimi"),
            React.createElement(
                "button",
                {
                    className: "btn btn-primary",
                    onClick: () => {
                        resetForm()
                        setShowModal(true)
                    },
                },
                React.createElement(FiPlus),
                "Yeni Personel",
            ),
        ),
        React.createElement(
            "div",
            { className: "desktop-table" },
            React.createElement(
                "div",
                { className: "card" },
                React.createElement(
                    "div",
                    { className: "table-container" },
                    React.createElement(
                        "table",
                        null,
                        React.createElement(
                            "thead",
                            null,
                            React.createElement(
                                "tr",
                                null,
                                React.createElement("th", null, "Ad Soyad"),
                                React.createElement("th", null, "Telefon"),
                                React.createElement("th", null, "Departman"),
                                React.createElement("th", null, "Durum"),
                                React.createElement("th", null, "Son Giriş"),
                                React.createElement("th", null, "İşlemler"),
                            ),
                        ),
                        React.createElement(
                            "tbody",
                            null,
                            users.map((user) =>
                                React.createElement(
                                    "tr",
                                    { key: user.id },
                                    React.createElement("td", null, `${user.first_name} ${user.last_name}`),
                                    React.createElement("td", null, user.phone),
                                    React.createElement("td", null, user.department?.name || "-"),
                                    React.createElement(
                                        "td",
                                        null,
                                        React.createElement(
                                            "span",
                                            { className: `badge ${user.is_active ? "badge-success" : "badge-danger"}` },
                                            user.is_active ? "Aktif" : "Pasif",
                                        ),
                                    ),
                                    React.createElement(
                                        "td",
                                        null,
                                        user.last_login_at ? new Date(user.last_login_at).toLocaleDateString("tr-TR") : "-",
                                    ),
                                    React.createElement(
                                        "td",
                                        null,
                                        React.createElement(
                                            "div",
                                            { className: "action-buttons" },
                                            React.createElement(
                                                "button",
                                                { className: "btn-icon", onClick: () => handleViewDetail(user), title: "Detay" },
                                                React.createElement(FiEye),
                                            ),
                                            React.createElement(
                                                "button",
                                                { className: "btn-icon", onClick: () => handleEdit(user), title: "Düzenle" },
                                                React.createElement(FiEdit2),
                                            ),
                                            user.role !== "admin" &&
                                            React.createElement(
                                                "button",
                                                { className: "btn-icon danger", onClick: () => handleDelete(user.id), title: "Sil" },
                                                React.createElement(FiTrash2),
                                            ),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
        ),
        React.createElement(
            "div",
            { className: "mobile-cards" },
            users.map((user) =>
                React.createElement(
                    "div",
                    { key: user.id, className: "mobile-card" },
                    React.createElement(
                        "div",
                        { className: "mobile-card-header" },
                        React.createElement(
                            "div",
                            { className: "mobile-card-avatar" },
                            `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase(),
                        ),
                        React.createElement(
                            "div",
                            { className: "mobile-card-title" },
                            React.createElement("h3", null, `${user.first_name} ${user.last_name}`),
                            React.createElement(
                                "span",
                                { className: `badge ${user.is_active ? "badge-success" : "badge-danger"}` },
                                user.is_active ? "Aktif" : "Pasif",
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "mobile-card-body" },
                        React.createElement(
                            "div",
                            { className: "mobile-card-row" },
                            React.createElement("span", { className: "mobile-card-label" }, "Telefon:"),
                            React.createElement("span", null, user.phone),
                        ),
                        React.createElement(
                            "div",
                            { className: "mobile-card-row" },
                            React.createElement("span", { className: "mobile-card-label" }, "Departman:"),
                            React.createElement("span", null, user.department?.name || "-"),
                        ),
                        React.createElement(
                            "div",
                            { className: "mobile-card-row" },
                            React.createElement("span", { className: "mobile-card-label" }, "Son Giriş:"),
                            React.createElement(
                                "span",
                                null,
                                user.last_login_at ? new Date(user.last_login_at).toLocaleDateString("tr-TR") : "-",
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "mobile-card-actions" },
                        React.createElement(
                            "button",
                            { className: "btn-icon", onClick: () => handleViewDetail(user), title: "Detay" },
                            React.createElement(FiEye),
                        ),
                        React.createElement(
                            "button",
                            { className: "btn-icon", onClick: () => handleEdit(user), title: "Düzenle" },
                            React.createElement(FiEdit2),
                        ),
                        user.role !== "admin" &&
                        React.createElement(
                            "button",
                            { className: "btn-icon danger", onClick: () => handleDelete(user.id), title: "Sil" },
                            React.createElement(FiTrash2),
                        ),
                    ),
                ),
            ),
        ),
        showModal &&
        React.createElement(
            "div",
            { className: "modal-overlay", onClick: () => setShowModal(false) },
            React.createElement(
                "div",
                { className: "modal", onClick: (e) => e.stopPropagation() },
                React.createElement("h2", null, selectedUser ? "Personel Düzenle" : "Yeni Personel"),
                error && React.createElement("div", { className: "error-message" }, error),
                React.createElement(
                    "form",
                    { onSubmit: handleSubmit },
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Ad *"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.first_name,
                                onChange: (e) => setFormData({ ...formData, first_name: e.target.value }),
                                required: true,
                            }),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Soyad *"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.last_name,
                                onChange: (e) => setFormData({ ...formData, last_name: e.target.value }),
                                required: true,
                            }),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Telefon *"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.phone,
                                onChange: (e) => setFormData({ ...formData, phone: e.target.value }),
                                required: true,
                            }),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "E-posta"),
                            React.createElement("input", {
                                type: "email",
                                value: formData.email,
                                onChange: (e) => setFormData({ ...formData, email: e.target.value }),
                            }),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, selectedUser ? "Şifre (boş bırakılırsa değişmez)" : "Şifre *"),
                            React.createElement("input", {
                                type: "password",
                                value: formData.password,
                                onChange: (e) => setFormData({ ...formData, password: e.target.value }),
                                required: !selectedUser,
                            }),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Departman"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.department_id,
                                    onChange: (e) => setFormData({ ...formData, department_id: e.target.value }),
                                },
                                React.createElement("option", { value: "" }, "Seçiniz"),
                                departments.map((dept) => React.createElement("option", { key: dept.id, value: dept.id }, dept.name)),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Yetkiler"),
                        React.createElement(
                            "div",
                            { className: "permissions-grid" },
                            permissions.map((perm) =>
                                React.createElement(
                                    "label",
                                    { key: perm.id, className: "checkbox-label" },
                                    React.createElement("input", {
                                        type: "checkbox",
                                        checked: formData.permissions.includes(perm.id),
                                        onChange: () => handlePermissionChange(perm.id),
                                    }),
                                    React.createElement("span", null, perm.name),
                                ),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "modal-actions" },
                        React.createElement(
                            "button",
                            { type: "button", className: "btn btn-secondary", onClick: () => setShowModal(false) },
                            "İptal",
                        ),
                        React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Kaydet"),
                    ),
                ),
            ),
        ),
        showDetailModal &&
        selectedUser &&
        React.createElement(
            "div",
            { className: "modal-overlay", onClick: () => setShowDetailModal(false) },
            React.createElement(
                "div",
                { className: "modal", onClick: (e) => e.stopPropagation() },
                React.createElement("h2", null, "Personel Detayı"),
                React.createElement(
                    "div",
                    { className: "detail-grid" },
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Ad Soyad:"),
                        React.createElement("span", null, `${selectedUser.first_name} ${selectedUser.last_name}`),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Telefon:"),
                        React.createElement("span", null, selectedUser.phone),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "E-posta:"),
                        React.createElement("span", null, selectedUser.email || "-"),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Departman:"),
                        React.createElement("span", null, selectedUser.department?.name || "-"),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Durum:"),
                        React.createElement(
                            "span",
                            { className: `badge ${selectedUser.is_active ? "badge-success" : "badge-danger"}` },
                            selectedUser.is_active ? "Aktif" : "Pasif",
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Yetkiler:"),
                        React.createElement(
                            "div",
                            { className: "permissions-list" },
                            selectedUser.permissions?.map((perm) =>
                                React.createElement("span", { key: perm.id, className: "badge badge-info" }, perm.name),
                            ),
                        ),
                    ),
                ),
                React.createElement(
                    "div",
                    { className: "modal-actions" },
                    React.createElement(
                        "button",
                        { className: "btn btn-secondary", onClick: () => setShowDetailModal(false) },
                        "Kapat",
                    ),
                ),
            ),
        ),
    )
}

export default Users
